import {useEffect} from "react";

export const useCustomEvent = (customEventName = "", callback) => {

    useEffect(() => {
        if (!!customEventName && typeof(callback) === "function") {
            CustomEventUtils.addListener(customEventName, callback);
            return () => {
                CustomEventUtils.removeListener(customEventName, callback);
            }
        }
    }, []);

}

class CustomEventUtils {
    static addListener (eventName, handler) {
        window.addEventListener(eventName, handler);
    }

    static removeListener (eventName, handler) {
        window.removeEventListener(eventName, handler);
    }

    static dispatchEvent (eventName) {
        window.dispatchEvent(new Event(eventName));
    }
    static dispatchCustomEvent (eventName, params) {
        window.dispatchEvent(new CustomEvent(eventName, params));
    }
}

export default CustomEventUtils;
